import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FilterHdrIcon(props: IconProps) {
    return <Icon {...props} iconKey={"filter_hdr"}/>
}
